export const today =
  new Date(new Date().setHours(12)).toISOString().substring(0, 10)

export const firstMonthDay =
  new Date(new Date().getFullYear(), new Date().getMonth(), 1, 12)
    .toISOString()
    .substring(0, 10)
